import React from 'react';
import { getFullItemName } from '../../../../utils/mrs-util';
import { formatNumber } from '../../../../utils/format-number-util';
import { TableRow, TableCell } from '@material-ui/core';

const ApproveLineItem = (props) => {
  return (
    <TableRow>
      <TableCell>
        {!!props.quitProduct ? (
          <>
          <div style={{ textDecoration: 'line-through' }}>
            {getFullItemName(props.item)}
          </div>
          <div style={{ color: 'red' }}>{"Quit Product"}</div>
        </>
        ) : (
          getFullItemName(props.item)
        )}
      </TableCell>
      <TableCell>{props.item.description}</TableCell>
      <TableCell>
        {!!props.originalFrequency &&
        props.frequency !== props.originalFrequency ? (
          <>
            <div style={{ textDecoration: 'line-through' }}>
              {props.originalFrequency}
            </div>
            <div style={{ color: 'red' }}>{props.frequency}</div>
          </>
        ) : (
          props.frequency
        )}
      </TableCell>
      <TableCell>
        {!!props.originalQuantity &&
        props.quantity !== props.originalQuantity ? (
          <>
            <div style={{ textDecoration: 'line-through' }}>
              {props.originalQuantity}
            </div>
            <div style={{ color: 'red' }}>{props.quantity}</div>
          </>
        ) : (
          props.quantity
        )}
      </TableCell>
      <TableCell>
        {props.rate !== props.originalRate ? (
          <>
            <div style={{ textDecoration: 'line-through' }}>
              ${formatNumber(props.originalRate, 2)}
            </div>
            <div style={{ color: 'red' }}>${formatNumber(props.rate, 2)}</div>
          </>
        ) : (
          `$${formatNumber(props.rate, 2)}`
        )}
      </TableCell>
    </TableRow>
  );
};

export default ApproveLineItem;
